import React from 'react'
import { InputGroup, Form, Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const HeaderInput = ({ ...rest }) => {

  const themeState = useSelector(state => state.themeState);

  return (
    <>
      <div className='header-input '>
        <InputGroup>
          <InputGroup.Text id="basic-addon1" >
            <Image
              src={themeState.themeMode === 'dark' ? '/assets/images/search-icon-dark.svg' : '/assets/images/search-icon.svg'}
            />
          </InputGroup.Text>
          <Form.Control
            placeholder="Search People & places"
            aria-label="Username"
            aria-describedby="basic-addon1"
            className='font-13 font-weight-normal'
          />
        </InputGroup>
      </div>
    </>
  )
}

export default HeaderInput
